import {
    Component,
    OnInit,
    Input,
    ElementRef,
    ViewChild,
    Output,
    EventEmitter,
} from "@angular/core";
import { FileDownloaderServices } from "./file-downloader.service";
import { IFileDownloaderList } from "./npa-file-downloader.type";
import { NpaDataSource, NpaDatabase } from "../../classes/npa-table";
import { HttpService } from "src/app/services/http.service";
import { FileService } from "../../services/file.service";
import { HttpErrorResponse, HttpParams } from "@angular/common/http";
import { DropdownService } from "src/app/services/dropdown.service";
import { IDropdownData } from "../../types/general.types";
import { TranslateService } from "../../services/translate.service";
import { NPA_ALERTS } from "../../consts/messages";
import { ConfirmationService } from "../../services/confirmation.service";
import { IConfirmationDialogOutput } from "../../types/confirmation.type";
import { NotificationsService } from "../../services/notifications.service";
import { FileUploaderServices } from "../file-uploader/file-uploader.service";
import { AuthService } from "src/app/services/auth.service";
import { ItemService } from "src/app/services/item.service";

@Component({
    selector: "npa-file-downloader",
    templateUrl: "./npa-file-downloader.component.html",
    styleUrls: ["./npa-file-downloader.component.styl"],
})
export class FileDownloaderComponent implements OnInit {
    @ViewChild("parent", { static: false }) parent: ElementRef;
    @Input() resourceValue: string;
    attachments: any;
    dataSource: NpaDataSource;
    database: NpaDatabase;
    languages = [];
    @Input() isMisc: boolean = false;
    isData: boolean;
    @Output() isFileEmpty = new EventEmitter<boolean>();
    @Input() showDelete?: boolean = false;
    @Input() hasAdjustments: boolean = false;
    displayedColumns = ["number", "name", "type", "size", "language"];
    userPositions: string[] = [];
    privacyStatus = [
        {
            name_ps: "عام",
            name_prs: "عام",
            name_en: "Public",
            slug: "public",
        },
        {
            name_ps: "نورمال",
            name_prs: "نورمال",
            name_en: "Normal",
            slug: "normal",
        },
        {
            name_ps: "محرم",
            name_prs: "محرم",
            name_en: "Confidential",
            slug: "confidential",
        },
        {
            name_ps: "اشد محرم",
            name_prs: "اشد محرم",
            name_en: "Strictly Confidential",
            slug: "strictly-confidential",
        },
    ];
    user_pes: boolean = false;

    constructor(
        private fileDownloaderServices: FileDownloaderServices,
        private _http: HttpService,
        private _fileService: FileService,
        public dropdownService: DropdownService,
        public translateService: TranslateService,
        public confirmationService: ConfirmationService,
        private _notificationsService: NotificationsService,
        public fileUploaderServices: FileUploaderServices,
        public authService: AuthService,
        public itemService: ItemService
    ) {}

    ngOnInit() {
        if (this.showDelete) {
            this.displayedColumns.push("option");
        }
        // if (!this.authService.isPublicUser) {
        //     this.authService.loggedInUser.positions.map((position) =>
        //         this.userPositions.push(position.slug)
        //     );
        //     const loggedInUserSubPartySlug = (
        //         this.authService.loggedInUser || ({} as any)
        //     ).sub_party_slug;
        //     const procurementEntitySlug =
        //         this.itemService.info.getValue().data.procurement_entity_slug;
        //     loggedInUserSubPartySlug === procurementEntitySlug &&
        //         (this.user_pes = true);
        // }
        const params = new HttpParams()
            .set("file_id", this.resourceValue)
            .set("user_pes", this.user_pes.toString())
            .set("user_positions", this.userPositions.join(","));
        this.fileDownloaderServices.showFiles(params).subscribe(
            (list: IFileDownloaderList[]) => {
                if (list.length > 0) {
                    this.isData = true;
                } else {
                    this.isData = false;
                }
                list.forEach((item) => {
                    item.language = this.dropdownService.getItem(
                        "commons",
                        "language",
                        item.language
                    );
                    item.privacy_status = this.privacyStatus.filter(
                        (ps) => ps.slug == item.privacy_status
                    )[0];
                    // item.privacy_status = this.dropdownService.getItem(
                    //     "references",
                    //     "privacy-status",
                    //     item.privacy_status
                    // );
                });
                this.database = new NpaDatabase(list);
                this.dataSource = new NpaDataSource(this.database);
            },
            (error) => {
                this.database = new NpaDatabase([]);
                this.dataSource = new NpaDataSource(this.database);
                console.error(error);
            }
        );
        this.dropdownService.getData("commons", "language").subscribe(
            (data: IDropdownData[]) => {
                this.languages = data;
                this.dropdownService.getItem("commons", "language", "da");
            },
            (error) => {
                console.error(error);
            }
        );
    }

    downloadFile(file): void {
        if (
            !this.authService.isPublicUser ||
            file.privacy_status.slug == "public"
        ) {
            this._http
                .download("api/attachments/download/" + file.id)
                .subscribe(
                    (res) => {
                        this._fileService.download(
                            this.parent,
                            res.body,
                            file.assigned_name
                        );
                        this.fileDownloaderServices.fileDownloaded(
                            file.assigned_name
                        );
                    },
                    (error: HttpErrorResponse) => {
                        console.error(error);
                    }
                );
        }
    }

    deleteFile(id) {
        this.confirmationService
            .openDialog({
                message: NPA_ALERTS[this.translateService.lang].DELETE_CONFIRM,
            })
            .then((result: IConfirmationDialogOutput) => {
                if (result.isConfirmed) {
                    this._notificationsService.startLoading();
                    this._http.delete("api/attachments/delete/" + id).subscribe(
                        (response) => {
                            this.fileUploaderServices
                                .hasFile(this.resourceValue)
                                .subscribe((result) => {
                                    if (result.isFile == false) {
                                        this.isFileEmpty.emit(true);
                                        this.isData = false;
                                    }
                                });
                            this.database.delete(id);
                            this._notificationsService.dismissLoading();
                        },
                        (error) => {
                            this._notificationsService.dismissLoading();
                            this._notificationsService.error(
                                NPA_ALERTS[this.translateService.lang].ERROR
                            );
                            console.error(error);
                        }
                    );
                }
            });
    }
}
